import React from 'react';
import {
  Stack,
  Typography,
  Button,
  Alert,
} from 'omaha-design-system';
import { Clock as ScheduleIcon } from '@phosphor-icons/react';
import { BottomSheetOrDialog } from './BottomSheetOrDialog';

interface StaleProjectionsBottomSheetProps {
  open: boolean;
  onClose: () => void;
  lastUpdatedTime: string | null;
}

export const StaleProjectionsBottomSheet: React.FC<StaleProjectionsBottomSheetProps> = ({
  open,
  onClose,
  lastUpdatedTime,
}) => {
  return (
    <BottomSheetOrDialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      detent="auto"
    >
      <Stack spacing={3} sx={{ p: 3 }}>
        {/* Title */}
        <Typography
          sx={{
            fontFamily: '"Gilroy", "Instrument Sans", sans-serif',
            fontWeight: 900,
            fontSize: '19.2px',
            lineHeight: 1.248,
            color: '#FFA726',
          }}
        >
          Stale Projections Warning
        </Typography>

        {/* Alert */}
        <Alert
          severity="warning"
          icon={<ScheduleIcon size={22} color="#FFA726" />}
          sx={{
            backgroundColor: 'rgba(255, 167, 38, 0.08)',
            border: '1px solid rgba(255, 167, 38, 0.5)',
            borderRadius: '6.67px',
            '& .MuiAlert-icon': {
              color: '#FFA726',
            },
            '& .MuiAlert-message': {
              color: '#F2F2F3',
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Instrument Sans", sans-serif',
              fontWeight: 600,
              fontSize: '13.33px',
              lineHeight: 1.5,
              color: '#F2F2F3',
            }}
          >
            Projections are over an hour old
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Instrument Sans", sans-serif',
              fontWeight: 400,
              fontSize: '13.33px',
              lineHeight: 1.5,
              color: '#F2F2F3',
            }}
          >
            Last updated: {lastUpdatedTime || '-'}
          </Typography>
        </Alert>

        {/* Warning Text */}
        <Typography
          sx={{
            fontFamily: '"Instrument Sans", sans-serif',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: 1.5,
            color: 'rgba(242, 242, 243, 0.7)',
          }}
        >
          These projections may be stale. Please ensure there hasn't been any significant news, injury updates, or lineup changes since the last run.
        </Typography>

        {/* Action Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={onClose}
          sx={{
            height: 48,
            borderRadius: '6.67px',
            backgroundColor: '#42A5F5',
            border: '1px solid rgba(42, 83, 195, 0.3)',
            fontFamily: '"Instrument Sans", sans-serif',
            fontWeight: 600,
            fontSize: '13.33px',
            lineHeight: 1.5,
            color: 'rgba(0, 0, 0, 0.87)',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#1976d2',
            },
          }}
        >
          I Understand
        </Button>
      </Stack>
    </BottomSheetOrDialog>
  );
};

export default StaleProjectionsBottomSheet;
